const style = {
  field: {
    sx: {
      mt: 2,
    },
  },
} as const;

export default style;
